import { __awaiter } from "tslib";
import { get } from 'svelte/store';
import Time from 'date-and-time';
import { AppState } from '../etc/stores';
import { Container } from './container';
import { StatefulService } from './stateful-service';
import { getParamsVisualTest } from '../etc/utils';
import { SessionManager } from './session-manager';
import { initTheme } from '../etc/themes';
const LOCATION_STORE = 'location-country';
export class Business extends StatefulService {
    constructor() {
        super(...arguments);
        this.session = this.ctx.get(SessionManager);
    }
    loadState() {
        return __awaiter(this, void 0, void 0, function* () {
            const { account } = yield this.getAuthState();
            const { id, business, settings } = yield this.backend.getBusiness(this.provider, account);
            if (!business) {
                return false;
            }
            business.loyaltyEnabled =
                parseInt(business.rewardsSettings.coinRewardPercentage.toString(), 10) >
                    0;
            business.oauthId = id;
            const visualParams = getParamsVisualTest();
            let theme = initTheme(visualParams.enabled && visualParams.color
                ? visualParams.color
                : settings.color);
            AppState.update(state => (Object.assign(Object.assign({}, state), { business,
                settings,
                theme })));
            return true;
        });
    }
    loadLocation() {
        return __awaiter(this, void 0, void 0, function* () {
            const { business } = get(AppState);
            let location = this.session.get(LOCATION_STORE);
            if (!location)
                location = yield this.backend.getCountryByName(business.country);
            this.session.set(LOCATION_STORE, location, {
                expires: Time.addDays(new Date(), 7),
                validBusiness: true
            });
            business.location = location;
            AppState.update(state => (Object.assign(Object.assign({}, state), { business })));
        });
    }
}
Container.add(Business);
